import { Component, type ReactNode } from 'react';

interface Props {
  children: ReactNode;
  fallback?: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

export default class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error('ErrorBoundary caught:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      if (this.props.fallback) return this.props.fallback;
      return (
        <div className="flex items-center justify-center h-full min-h-[400px]">
          <div className="flex flex-col items-center gap-4 text-center max-w-md">
            <i className="ri-error-warning-line text-5xl text-amber-500"></i>
            <div>
              <p className="text-lg font-semibold text-slate-800">页面加载失败</p>
              <p className="text-sm text-slate-500 mt-1">
                {this.state.error?.message || '网络异常或模块加载失败'}
              </p>
            </div>
            <button
              onClick={() => {
                this.setState({ hasError: false, error: null });
                window.location.reload();
              }}
              className="px-6 py-2.5 bg-gradient-to-r from-cyan-500 to-blue-500 text-white rounded-xl hover:shadow-lg transition-all text-sm font-medium"
            >
              <i className="ri-refresh-line mr-2"></i>
              重新加载
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
